export default __webpack_public_path__ + "static/1189-59b189d059900ccee8877f818dd941af.gif";